import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import GeneralInfoFields from './StepFields/GeneralInfoFields';
import BusinessProfileFields from './StepFields/BusinessProfileFields';
import CapabilitiesFields from './StepFields/CapabilitiesFields';
import PastPerformanceFields from './StepFields/PastPerformanceFields';
import BondingFields from './StepFields/BondingFields';
import InsuranceAndSafetyFields from './StepFields/InsuranceAndSafetyFields';
import SecurityAndCertificationsFields from './StepFields/SecurityAndCertificationsFields';
import ComplianceFields from './StepFields/ComplianceFields';
import SignatureFields from './StepFields/SignatureFields';
import { getPath } from '../steps';

const stepToComponent: {
  [key: string]: any,
} = {
  'General Info': GeneralInfoFields,
  'Business Profile': BusinessProfileFields,
  'Capabilities': CapabilitiesFields,
  'Past Performance': PastPerformanceFields,
  'Bonding': BondingFields,
  'Insurance and Safety': InsuranceAndSafetyFields,
  'Security and Certifications': SecurityAndCertificationsFields,
  'Compliance': ComplianceFields,
  'Signature': SignatureFields,
};

type FormContentProps = {
  steps: string[],
}

const FormContent = ({ steps }: FormContentProps) => {
  return (
    <Switch>
      {steps.map((step, index) => (
        <Route key={step} path={getPath(steps, index)} component={stepToComponent[step]} />
      ))}
      <Redirect to={getPath(steps, 0)} />
    </Switch>
  );
}

export default FormContent;
